import "./App.css";
import { audioFiles } from "./audioFiles";
import Container from "./Container";

function App() {
  return (
    <div className="App">
      <Container items={audioFiles}></Container>
    </div>
  );
}

export default App;
